import styled from 'styled-components'
import { H1 } from '@/components/Typography'

export const PageTitle = styled(H1)`
  grid-area: title;
  margin: 0 0 1rem 0;
  color: ${({ theme }) => theme.edukRed};
`
